import type { AnalyticsProvider } from '@/services/analytics';
import { loadScript } from '@/utils/script.utils';

export class GoogleTagManagerAnalytics implements AnalyticsProvider {
  public readonly name = 'google-tag-manager';
  // This container mixes Google Analytics and Ads tags.
  public readonly consentCategories = ['analytics', 'marketing'] as const;

  public init(): Promise<void> {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    return loadScript('https://www.googletagmanager.com/gtm.js?id=GTM-WZDVK8ZM');
  }
}
